import {keyBy, omit} from 'lodash';

import {
  RECEIVE_FEATURE_FLAGS,
  ADD_OR_EDIT_FEATURE_FLAG,
  DELETE_FEATURE_FLAG,
} from '../actions/feature-flags';

export default (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_FEATURE_FLAGS:
      return {...state, ...keyBy(action.featureFlags, 'id')};
    case ADD_OR_EDIT_FEATURE_FLAG:
      if (!state[action.featureFlag.id]) {
        return {
          [action.featureFlag.id]: action.featureFlag,
          ...state,
        };
      }

      return {
        ...state,
        [action.featureFlag.id]: {...state[action.featureFlag.id], ...action.featureFlag},
      };
    case DELETE_FEATURE_FLAG:
      return omit(state, action.id);
    default:
      return state;
  }
};
